<template>
  <div class="login-wrapper">
    <div class="login-container">
      <img v-if="logoExists" src="../assets/logosays.png" alt="Logo Says" class="logo">
      <h2 class="title">Verificador de Zelle</h2>
      <p class="subtitle">Inicia sesión para continuar</p>
      <form @submit.prevent="handleLogin">
        <div class="input-group">
          <input type="email" id="email" v-model="email" placeholder="Correo Electrónico" required>
        </div>
        <div class="input-group">
          <input type="password" id="password" v-model="password" placeholder="Contraseña" required>
        </div>
        <button type="submit" class="login-button">Ingresar</button>
        <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'LoginComponent',
  data() {
    return {
      email: '',
      password: '',
      errorMessage: '',
      logoExists: true
    };
  },
  methods: {
    async handleLogin() {
      this.errorMessage = '';
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.post(`${apiUrl}/clientesweb/login`, {
          email: this.email,
          password: this.password
        });

        if (response.data.status === 'Success') {
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('user', JSON.stringify(response.data.user));
          this.$router.push('/welcome');
        } else {
          this.errorMessage = response.data.message;
        }
      } catch (error) {
        this.errorMessage = 'Ocurrió un error al intentar iniciar sesión.';
        console.error('Error en el login:', error);
      }
    }
  }
};
</script>

<style scoped>
.login-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f0f2f5;
}

.login-container {
  width: 100%;
  max-width: 400px;
  padding: 40px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.logo {
  max-width: 150px;
  margin-bottom: 20px;
}

.title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.subtitle {
  font-size: 16px;
  color: #666;
  margin-bottom: 30px;
}

.input-group {
  margin-bottom: 20px;
}

input {
  width: 100%;
  padding: 12px 15px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
  transition: border-color 0.3s;
}

input:focus {
  outline: none;
  border-color: #42b983;
}

.login-button {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  background-color: #42b983;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.login-button:hover {
  background-color: #369f72;
}

.error-message {
  color: #e74c3c;
  margin-top: 15px;
}
</style>
